<template>
  <div>
    <v-row v-if="user.business_token">
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            :api-url="apiUrl"
            :show-submit-and-clear-btn="false"
            :show-creation-data="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            :show-actions="false"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CurrencyForm"
        >
          <template #default>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    class="text-field-ltr rounded-lg"
                    label=" * نام کاربری"
                    v-model="item.username"
                    :disabled="true"
                />
              </v-col>

              <template>
                <v-col cols="6">
                  <v-text-field
                      class="text-field-ltr rounded-lg"
                      type="number"
                      label="شماره موبایل"
                      v-model="item.mobile_number"
                      required
                      :disabled="true"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field label="نام" v-model="item.first_name" :disabled="true" class="rounded-lg"/>
                </v-col>
                <v-col cols="4">
                  <v-text-field label="نام خانوادگی" v-model="item.last_name" :disabled="true" class="rounded-lg"/>
                </v-col>
                <v-col cols="4">
                  <v-text-field label="کد پستی" v-model="item.postal_code" :disabled="true" class="rounded-lg"/>
                </v-col>
                <v-col cols="12">
                  <v-textarea label="ادرس" v-model="item.address" rows="2" :disabled="true" class="rounded-lg"/>
                </v-col>
              </template>
            </v-row>
          </template>
        </m-form>

      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="error white--text">کسب و کار فعال نیست
          </v-card-title>
        </v-card>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "AffiliateCustomers",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'affiliate/customers',
      baseUrl: "affiliate/customers",
      permissionBasename: "user",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام",
          value: "first_name",
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
        },
        {
          text: "نام کاربری",
          value: "username",
        },
        {
          text: "شماره تلفن",
          value: "mobile_number",
        },
      ],

    };
  },
  computed: {
    apiUrl() {
      return `affiliate/customers?businessToken=${this.user.business_token}`
    },
    title() {
      return 'مشتری ها'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {

  },
}
</script>

<style scoped lang="scss"></style>

